// SVMD site data — single source of truth
export const SITE = {
  name: "SVMD & Associates",
  shortName: "SVMD",
  descriptor: "Chartered Accountants",
  // Office number (everywhere except WhatsApp)
  phoneDisplay: "+91 93447 33377",
  phoneTel: "+919344733377",
  email: "office@svmd.in",
  // WhatsApp stays on the partner number
  whatsappNumber: "918870208882",
  whatsappUrl: "https://wa.me/918870208882",
  arattaiUrl: "https://aratt.ai/@insights_svmd",
  address: {
    line1: "373/3, Mettupalayam Road",
    line2: "Near FACT, Vadakovai",
    line3: "Coimbatore – 641043",
  },
  coordinates: { lat: 11.019766, lng: 76.953854 },
  partners: [
    {
      slug: "vaibhav",
      name: "Sri Vaibhav V",
      credentials: "ACA",
      role: "Partner — Growth and Financial Strategy",
      email: "vaibhav@svmd.in",
      phoneDisplay: "+91 70103 41301",
      phoneTel: "+917010341301",
      linkedin: "https://www.linkedin.com/in/sri-vaibhav/",
      photo: "/team/vaibhav.png",
      bio: "Vaibhav works with organisations to strengthen governance, internal controls, and financial operations. With experience across multinational and large-scale environments, his approach is structured and systems-driven focused on building reliable frameworks that support scale and consistency. His work centres around bringing clarity into financial processes, improving visibility for leadership, and ensuring that businesses operate with discipline as they grow.",
      focus: [
        "Controllership and financial close",
        "Internal controls and governance frameworks (including SOX/ICFR)",
        "Internal and management audits",
        "Investigations and process reviews",
        "Financial systems and workflow optimisation",
      ],
    },
    {
      slug: "mithuna",
      name: "Mithuna D V",
      credentials: "Bachelor of Commerce, ACA",
      role: "Partner — Tax, Compliance and Regulatory Strategy",
      email: "mithuna@svmd.in",
      phoneDisplay: "+91 88702 08882",
      phoneTel: "+918870208882",
      linkedin: "https://www.linkedin.com/in/mithuna-d-v-61a842178/",
      photo: "/team/mithuna.png",
      bio: "Mithuna works closely with businesses on tax compliance, financial planning, and documentation-driven processes. Her approach is organised and execution-focused, ensuring that statutory requirements are handled cleanly and consistently. She focuses on building clarity in filings, strengthening planning routines, and setting up structures that support smooth day-to-day financial operations.",
      focus: [
        "Income Tax and GST compliance",
        "Financial planning and projections",
        "Budgeting and operational support",
        "Documentation and bookkeeping structures",
        "Experience across manufacturing, services, NGOs, education, and trading",
      ],
    },
  ],
  advisor: {
    name: "CA Padmanabhan R",
    credentials: "FCA, DISA, M.Com, M.Phil, MBA",
    role: "Senior Advisor",
    yearsLabel: "33",
    yearsCaption: "years",
    bio: "CA Padmanabhan R is a senior Chartered Accountant with over 33 years of professional practice, and is a trusted advisor to SVMD & Associates. Drawing from his extensive experience in statutory, concurrent, stock and receivables audits for banks, public sector audits allotted by CAG, and information systems audits, he provides senior-level guidance on audit approach, risk assessment, regulatory alignment, and quality assurance. He advises the firm on key aspects of banking audits, including audit planning, interpretation of regulatory requirements, handling of complex audit issues, and strengthening of documentation and reporting practices. With a strong foundation in Information Systems Audit and technology-enabled audits, and recent exposure to artificial intelligence programs conducted by ICAI, he brings a forward-looking yet disciplined perspective to audit oversight. His association strengthens the firm's audit quality framework and reinforces a culture of regulatory discipline, professional judgement, and governance-focused assurance.",
  },
};

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  {
    label: "Services",
    href: "/services",
    children: [
      { label: "All Services", href: "/services", desc: "Audit, Tax, Governance & more" },
      { label: "Representation & Dispute", href: "/representation-and-dispute", desc: "Notices, assessments & disputes" },
      { label: "MSME Payment Recovery", href: "/msme-recovery", desc: "Recover delayed payments" },
    ],
  },
  { label: "Contact", href: "/contact" },
];
